import Ps from 'perfect-scrollbar';

class Header {
    constructor (context, settings, $, debounce) {
        // Environment variables
        this.context  = context;
        this.settings = settings;
        this.$        = $;

        // Document
        this.$document        = this.$(document);
        this.$window          = this.$(window);
        this.mobileBreakpoint = 900;

        // Elements
        //----------------------------------------
        this.$body = this.$('body', this.context).once();
        this.$main = this.$('main', this.context).once();

        // Header
        this.$header    = this.$('.js-header', this.context).once();
        this.$headerTop = this.$('.js-header-top', this.context).once();

        // Mobile menu
        this.$mobileMenuButton = this.$('.js-mobile-menu-toggle', this.context).once();
        this.$mobileMenu       = this.$('.js-mobile-menu', this.context).once();
        this.$browsealoudLink  = this.$('.js-browsealoud-link', this.context).once();

        // Search
        this.$searchFormWrapper      = this.$('.js-header-search', this.context).once();
        this.$searchForm             = this.$('.js-header-search-form', this.context).once();
        this.$searchField            = this.$('.js-header-search-field', this.context).once();
        this.$searchOpenButton       = this.$('.js-header-search-open', this.context).once();
        this.$searchCloseButton      = this.$('.js-header-search-close', this.context).once();
        this.$searchButtonBackground = this.$('.js-search-button-background', this.context).once();

        // Scrollbars
        //----------------------------------------
        this.scrollbars = [];

        if (!this.$('html').hasClass('no-classlist')) {
            this.addScrollbars();
            // On load init the scrollbars
            this.$window.on('load', this.$.proxy(this.addScrollbars, this));

            this.$window.on('resize', this.$.proxy(this.updateScrollbars, this));
        }

        // Events
        //----------------------------------------
        this.$window.on('resize', debounce(() => {
            if (this.$window.width() > this.mobileBreakpoint) {
                this.closeMobileMenu();
                this.closeSearch();
                this.destroyScrollbars();
            }
        }, 300));

        this.$document.keyup((e) => {
            // Escape Key
            if (e.keyCode === 27) {
                this.closeSearch();
                this.closeMobileMenu();
            }
        });

        // Preventing bug where transitions are appearing on page load
        this.$window.on('load', () => {
            this.$searchButtonBackground.removeClass('u-preload-transition-fix');
            this.$searchOpenButton.removeClass('u-preload-transition-fix');
        });

        if (this.$window.width() < this.mobileBreakpoint) {
            this.$browsealoudLink.remove();
        }

        this.$window.on('scroll', () => {
            // General sticky header
            if (!this.$mobileMenu.hasClass('is-open')) {
                this.stickyHeader();
            }
        });

        // Mobile menu events
        this.$mobileMenuButton.on('click', (e) => {
            this.toggleMobileMenu(e);

            if (!this.$('html').hasClass('no-classlist')) {
                this.addScrollbars();
            }
        });

        // Search Events
        this.$searchOpenButton.on('click', $.proxy(this.openSearch, this));
        this.$searchCloseButton.on('click', $.proxy(this.closeSearch, this));
    }

    toggleMobileMenu (e) {
        e.preventDefault();
        const $elem = this.$(e.currentTarget);

        $elem.toggleClass('is-clicked');

        if ($elem.hasClass('is-clicked')) {
            $elem.attr('aria-expanded', 'true');
        }
        else {
            $elem.attr('aria-expanded', 'false');
        }

        this.$body.toggleClass('scroll-locked');
        this.$mobileMenu.fadeToggle().addClass('is-open');
    }

    closeMobileMenu () {
        this.$body.removeClass('scroll-locked');
        this.$mobileMenu.removeAttr('style').removeClass('is-open');
    }

    openSearch (e) {
        e.preventDefault();
        const $elem = this.$(e.currentTarget);

        // 1. Hide the search button
        $elem.addClass('is-hidden');

        // 2. Show the background behind the button
        this.$searchButtonBackground.addClass('is-visible');

        // 3. Show the close button
        this.$searchCloseButton.addClass('is-visible');

        // 4. Show the search wrapper
        this.$searchFormWrapper.addClass('is-visible');

        // 5. Fade in the form
        this.$searchForm.addClass('fade-in');

        // 6. Wait for CSS animations to finish before focusing
        setTimeout(() => {
            this.$searchField.focus();
        }, 900);
    }

    closeSearch () {
        this.$searchForm.removeClass('fade-in');
        this.$searchFormWrapper.removeClass('is-visible');
        this.$searchButtonBackground.removeClass('is-visible');
        this.$searchCloseButton.removeClass('is-visible');
        this.$searchOpenButton.removeClass('is-hidden');
    }

    stickyHeader () {
        let windowScrollTop   = this.$window.scrollTop();
        const topHeaderHeight = this.$header.outerHeight(true);

        if (windowScrollTop > topHeaderHeight) {
            if (!this.$header.hasClass('is-sticky')) {
                this.$header.addClass('is-sticky');
                this.$main.css('paddingTop', this.$headerTop.outerHeight(true));
            }
        }
        else {
            this.$header.removeClass('is-sticky');
            this.$main.removeAttr('style');
        }
    }

    addScrollbars () {
        for (let i = 0; i < this.$mobileMenu.length; i++) {
            this.scrollbars.push(new Ps(this.$mobileMenu[i], {
                wheelPropagation: false,
                wheelSpeed      : 0.3,
            }));
        }
    }

    updateScrollbars () {
        this.scrollbars.forEach((ps) => ps.update());
    }

    destroyScrollbars () {
        this.scrollbars.forEach((ps) => ps.destroy());
    }
}

export default Header;
